import DocumentHeader from '@/components/DocumentHeader';
import type { ReactNode } from 'react';
import { NarrativeSkeletonLoader } from './NarrativeSkeletonLoader';
import { NarrativeGenericError } from './NarrativeGenericError';

type Props = {
  title: string;
  children: ReactNode;
  isLoading: boolean;
  error: string | boolean | undefined;
};

export const NarrativeLayout = ({
  title,
  children,
  isLoading,
  error,
}: Props) => {
  const renderContent = () => {
    if (isLoading) {
      return <NarrativeSkeletonLoader />;
    }

    if (error) {
      return <NarrativeGenericError>{error}</NarrativeGenericError>;
    }

    return children;
  };
  return (
    <section className="relative w-full max-w-screen-xl lg:p-x3 lg:pt-x1">
      <DocumentHeader title={title} />

      <div className="grid gap-x2 pt-x2">{renderContent()}</div>
    </section>
  );
};
